import { createSelector } from 'reselect';

import getStaticPropsSelector from './getStaticPropsSelector';

export default createSelector(getStaticPropsSelector, (staticProps): boolean => staticProps?.fetched === true);
